export class UrlHelper {
    static isExternalUrl(url: string): boolean {
        return url && url.toLocaleLowerCase().startsWith('http');
    }
}